<template>
  <!-- eslint-disable max-len -->
  <div
    :class="['main-view', { 'mobile': isMobile}]"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view ref="body" />
    </transition>
  </div>
</template>

<script>
// import Header from '@/components/Header.vue';
import debounce from 'lodash/debounce';

export default {
  name: 'MainView',

  components: { },

  data() {
    return {
      state: 'released',
      bodyVisible: false,
      headerVisible: false,
    };
  },

  computed: {
    routeName() {
      return this.$route.name;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    debug() {
      return this.$store.state.debug;
    },
  },

  watch: {
    routeName(to, from) {
      if (this.$store.state.isMobile) window.scrollTo(0, 0);
      this.updateHtmlClass(to, from);
    },
  },

  mounted() {
    this.handleResize();
    this._debouncedHandleResize = debounce(this.handleResize, 100);
    window.addEventListener('resize', this._debouncedHandleResize);
    this.updateHtmlClass(this.routeName);
  },

  beforeDestroy() {
    this.updateHtmlClass(undefined, this.routeName);
    window.removeEventListener('resize', this._debouncedHandleResize);
  },

  methods: {
    handleResize() {
      console.log('resize detected');
      if (window.innerWidth <= parseInt(this.$tokens.bp_mobile, 0)) {
        this.$store.commit('setMobile', true);
      } else {
        this.$store.commit('setMobile', false);
      }
    },
    updateHtmlClass(newPage, oldPage = undefined) {
      const root = document.getElementsByTagName('html')[0];
      if (newPage) root.classList.add(`landing-${newPage}`);
      if (oldPage) root.classList.remove(`landing-${oldPage}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main-view {
  position: relative;
  width: 100%;
  height: auto;


  &.mobile {
    // overflow: hidden; // CAN FIX SEVERAL ISSUES BUT WILL RPEVENT STICKY
  }

  #app.safari & {
  }
}
</style>
